import styled from 'styled-components';
import { CssSpace } from '@xbcb/ui-types';

export const StyledRenderedHtmlIframe = styled.iframe`
  border: none;
  border-radius: ${CssSpace.SPACE_1};
  width: 100%;
  margin-bottom: ${CssSpace.SPACE_4};
`;
